

module.config(function($stateProvider) {

    $stateProvider.state('program.initiatives', {
        abstract: true,
        url: '/initiatives',
        templateUrl: 'empty',
        permission: 'viewInitiatives',
        resolve: {
            urlBuilder: function(ApiUrl, program) {
                return ApiUrl.partial('program', program.id, 'initiatives');
            },
        }
    });

    $stateProvider.state('program.initiatives.index', {
        url: '',
        templateUrl: 'programs/initiatives/index',
        resolve: {
            initiatives: function($http, momentConvertFilter, urlBuilder) {
                var url = urlBuilder()
                return $http.get(url).then(function(response) {
                    return response.data.initiatives;
                }).then(momentConvertFilter);
            },
        },
        controller: 'ProgramInitiativeIndexController'
    });


    $stateProvider.state('program.initiatives.index.add', {
        url: '/add',
        templateUrl: 'programs/initiatives/add',
        permission: 'createInitiatives',
        resolve: {
            available: function($http, urlBuilder) {
                return $http.get(urlBuilder('available')).then(function(response) {
                    return response.data;
                });
            },
        },
        controller: 'NewProgramInitiativeController',
    });

    $stateProvider.state('program.initiatives.view', {
        url: '/{initId:[a-z][a-z0-9]{1,4}}',
        templateUrl: 'programs/initiatives/view',
        resolve: {
            initiative: function($http, $stateParams, urlBuilder) {
                return $http.get(urlBuilder($stateParams.initId))
                    .then(function(response) {
                        return response.data;
                    });
            },
            grantYears: function($http, $stateParams, ApiUrl) {
                if ($stateParams.initId === 'amc') {
                    return $http.get(ApiUrl('initiatives', 'americorps', 'grant-year'))
                        .then(function(response) {
                            return response.data.grant_years;
                        })
                }
                return [];
            },
        },
        controller: 'ViewProgramInitiativeController',
    });

});
